import {
  OrganizationRootDetails,
  OrganizationRootDetailsAdapter,
  WAREHOUSE_CHECKIN_DISABLED,
} from "@/core/models/organizationRootDetails";
import { Api } from "@/core/services/api.service";
import identificationService from "@/core/services/identification.service";
import { ADMIN, SUPER_ADMIN } from "@/core/models/usersAndPermissions";
import useOrganizationRootDetailsStore from "@/core/store/organizationRootDetailsStore";
import { OrganizationRootDetailApi } from "@/apps/shared/organization/core/infrastructure/repository/OrganizationRootDetailApi";

export const ORDservice = {
  async fetchORDByOrganizationId(accountId: string): Promise<OrganizationRootDetailApi> {
    const response = await Api.new().get(`/accounts/${accountId}/organization-root-detail`);

    return response.data;
  },
  async getORDByOrganizationId(organizationId: string): Promise<OrganizationRootDetails> {
    const organizationRootDetailsApi = await this.fetchORDByOrganizationId(organizationId);
    return OrganizationRootDetailsAdapter.adapt(organizationRootDetailsApi);
  },

  async updateOrganizationRootDetails(
    organizationRootDetailId: string,
    updateData: Partial<OrganizationRootDetailApi>
  ) {
    const response = await Api.new().patch(`organization-root-details/${organizationRootDetailId}`, updateData, {
      headers: { "Content-Type": "application/merge-patch+json" },
    });

    const { organizationRootDetails, setFromOrdApi } = useOrganizationRootDetailsStore();
    if (organizationRootDetails !== undefined) {
      setFromOrdApi({
        ...organizationRootDetails,
        ...response.data,
      });
    }
  },

  async updateEnabledPremiumFeatures(
    organizationRootDetailId: string,
    enabledPremiumFeatures: string[]
  ): Promise<void> {
    await Api.new().patch(
      `organization-root-details/${organizationRootDetailId}`,
      { enabledPremiumFeatures },
      {
        headers: { "Content-Type": "application/merge-patch+json" },
      }
    );
  },

  getOrganizationRootDetails(): OrganizationRootDetails | null {
    return useOrganizationRootDetailsStore().organizationRootDetails ?? null;
  },

  isWarehouseCheckinDisabled(): boolean {
    // In case of user being ADMIN or SUPER_ADMIN, there are no ORD to test
    const userTypes = identificationService.getUser()?.types;
    if (userTypes && [ADMIN, SUPER_ADMIN].some((type) => userTypes.includes(type))) {
      return true;
    }
    return WAREHOUSE_CHECKIN_DISABLED === this.getOrganizationRootDetails()?.warehouseCheckinRequirement;
  },
};
